import type React from 'react';
import type { FieldMetaState } from 'react-final-form';

import styles from './WarningMessage.module.scss';

const WarningMessage: React.FC<{
  meta?: FieldMetaState<string>;
}> = ({ meta }) =>
  meta?.data?.warning ? (
    <p className={styles.inlineValidationWarning}>{meta.data.warning}</p>
  ) : null;

export default WarningMessage;
